import { LoadingBarProcess } from '@shared';
import MasterLayout from '@shared/layouts/MasterLayout';
import React from 'react';
import { Route, Routes } from 'react-router-dom';

const PromotionListPage = React.lazy(() => import('pages/PromotionList/PromotionList'));

const PromotionListRoutes = () => {
  return (
    <Routes>
        <Route path="/" element={<MasterLayout />}>
            <Route
                index
                element={
                    <React.Suspense fallback={<LoadingBarProcess />}>
                        <PromotionListPage />
                    </React.Suspense>
                }
            />
        </Route>
    </Routes>
  )
}

export default PromotionListRoutes